import { Breadcrumb, BreadcrumbLink, Breadcrumbs } from '@rematter/ui-web';
import { useAtom, useAtomValue } from 'jotai';

import { $currentFolderId, $currentFolderPath } from '../../_state/files.state';

export const FileBreadcrumbs = () => {
  const [, setCurrentFolderId] = useAtom($currentFolderId);
  const currentPath = useAtomValue($currentFolderPath);

  const handleNavigate = (folderId: string | null) => {
    setCurrentFolderId(folderId || undefined);
  };

  return (
    <Breadcrumbs className="@FileBreadcrumbs">
      <Breadcrumb>
        <BreadcrumbLink onPress={() => handleNavigate(null)}>
          Files
        </BreadcrumbLink>
      </Breadcrumb>
      {currentPath.map((segment, index) => {
        const isLast = index === currentPath.length - 1;

        return (
          <Breadcrumb key={segment.id}>
            {isLast ? (
              <BreadcrumbLink>{segment.name}</BreadcrumbLink>
            ) : (
              <BreadcrumbLink onPress={() => handleNavigate(segment.id)}>
                {segment.name}
              </BreadcrumbLink>
            )}
          </Breadcrumb>
        );
      })}
    </Breadcrumbs>
  );
};
